import type { Dictionary } from '../bs'
import { common } from './common'
import { auth } from './auth'
import { shell } from './shell'
import { home } from './home'
import { submissions } from './submissions'
import { tasks } from './tasks'
import { fiveS } from './fiveS'
import { profile } from './profile'
import { notifications } from './notifications'
import { analytics } from './analytics'
import { admin } from './admin'
import { guide } from './guide'
import { owner } from './owner'
import { people } from './people'

/**
 * Serbian: Bosnian, moved from ijekavica to ekavica.
 *
 * Almost every entry is the same word with the jat reflex changed — *uspjela*
 * to *uspela*, *mjesec* to *mesec*, *sljedeće* to *sledeće*, *provjerite* to
 * *proverite*. A few are lexical and would be missed by any mechanical rule:
 * *prijedlog* → *predlog*, *bezbjednosni* → *bezbednosni*.
 *
 * Written in **Latin script**, matching the rest of the application. Serbian is
 * digraphic, and a Cyrillic interface is a separate locale rather than a
 * spelling of this one — the employee codes, exports and printed QR badges are
 * all Latin, so transliterating a handful of labels would produce a screen that
 * is half one alphabet and half the other.
 */
export const sr: Partial<Dictionary> = {
  ...common,
  ...auth,
  ...shell,
  ...home,
  ...submissions,
  ...tasks,
  ...fiveS,
  ...profile,
  ...notifications,
  ...analytics,
  ...admin,
  ...guide,
  ...owner,
  ...people,
}
